module.exports = __webpack_public_path__ + "img/home3.16050dc2.png";